import { settings } from '@alme/ui-web/settings/settings-util';
import * as conversation from '@alme/ui-web/ref/lib-alme-request';
import reduceReducers from 'reduce-reducers';
import { combineReducers } from 'redux';


import EndFeedbackAppEvent from '@alme/ui-web/ref/appevent-feedback-response';
import LanguageNormalizationModule from '@alme/ui-web/ref/normalize-language';


function setupReducers(components, initialization){
    const reducers = {};

    components.languageNormalizationModule = new LanguageNormalizationModule(settings);
    components.endFeedbackAppevent = new EndFeedbackAppEvent(settings);
    

    // Use reduceReducers on history component reducers
    const feedbackOverlayReducer = components.chatSurveyOverlay.getReducer();
    const initGetHistoryReducer = components.initializeGetHistory.getReducer();
    const historyAppenderReducer = components.historyAppender.getReducer();
    reducers.historyReducer = reduceReducers(initGetHistoryReducer, historyAppenderReducer, feedbackOverlayReducer, components.endSessionRequestProcessor.getReducer());

    reducers.persistentStorageReducer = components.persistentStorage.getReducer();
    const persistenceReducer = components.persistenceStrategy.getReducer();

    // Get the reducers for the other components
    reducers.emptyReducer = (state={}) => { return state; };

    reducers.conversationReducer = reduceReducers(
        conversation.getReducer(),
        components.languageNormalizationModule.getReducer(),
        components.customLanguageSetup.getReducer(),
        components.sessionManager.getReducer()
    );

    reducers.initializeReducer = initialization.getReducer();
    reducers.clientCommunicatorReducer = components.clientCommunicator.getReducer();
    reducers.launchMessageProcessorReducer = components.launchMessageProcessor.getReducer();
    reducers.autoNavReducer = components.autoNavUrl.getReducer();
    reducers.advocacyReducer = components.advocacy.getReducer();
    reducers.generateNewSessionReducer = components.generateNewSession.getReducer();
    reducers.endFeedbackReducer = components.endFeedbackAppevent.getReducer();
    reducers.mobileDeviceDetector = components.mobileDeviceDetector.getReducer();
    reducers.surveyReducer = components.feedbackOverlay.getReducer();
    reducers.initializationDataHandler = components.initializationDataHandler.getReducer();
    reducers.accessKeyHandler = components.accessKeyHandler.getReducer();
    reducers.stateTriggerer = components.stateTriggerer.getReducer();
    reducers.skinnerReducer = components.skinner.getReducer();
    reducers.stateCopierReducer = components.stateCopier.getReducer();
    reducers.liveChatFoundationReducer = components.liveChatFoundation.getReducer();
    reducers.almeNotifications = components.almeNotificationsApi.getReducer();
    reducers.changeRoleIdProcessor = components.changeRoleIdProcessor.getReducer();
    reducers.changeLocaleProcessor = components.changeLocaleProcessor.getReducer();
    reducers.searchInputProcessor = components.searchInputProcessor.getReducer();
    reducers.launchOffersProcessor = components.launchOffersProcessor.getOfferReducer();
    reducers.platformIdProcessor = components.platformIdProcessor.getReducer();
    reducers.processLocale = components.processLocale.getReducer();
    reducers.welcomeUserReducer = reduceReducers(
        components.welcomeUserAppevent.getReducer(),
        components.launchOffersProcessor.getWelcomeUserReducer(),
        components.ponLaunchMessageProcessor.getReducer()
        );

    reducers.livechatReducer = reduceReducers(
        components.requestProcessorChatAllowed.getReducer(),
        components.missedChatCounter.getReducer()
    );

    reducers.almeWindowReducer = reduceReducers(
        components.almeWindow.getReducer(),
        components.customAlmeWindowLaunchPoint.getReducer(),
        components.launchOffersProcessor.getSEFlowReducer(),
        components.embeddedIva.getReducer()
    );

    // Combine the reducers with combineReducers
    const rootReducer = combineReducers({
        [settings.stateLocations.Window.Base] : reducers.almeWindowReducer,
        [settings.stateLocations.Conversation.Base] : reducers.conversationReducer,
        [settings.stateLocations.History.Base] : reducers.historyReducer,
        [settings.stateLocations.PersistentStorage.Base] : reducers.persistentStorageReducer,
        [settings.stateLocations.AutoNav.Base] : reducers.autoNavReducer,
        [settings.stateLocations.Advocacy.Base] : reducers.emptyReducer,
        [settings.stateLocations.WelcomeUser.Base] : reducers.welcomeUserReducer,
        [settings.stateLocations.ClientCommunicator.Base] : reducers.clientCommunicatorReducer,
        [settings.stateLocations.Initialization.Base] : reducers.emptyReducer,
        [settings.stateLocations.DeviceType]: reducers.mobileDeviceDetector,
        [settings.stateLocations.Survey.Base] : reducers.surveyReducer,
        //[settings.stateLocations.PersistentStorageFlags.Base] : reducers.emptyReducer,
        [settings.stateLocations.AlmeNotifications.Base] : reducers.almeNotifications,
        [settings.stateLocations.GenerateNewSession.Base] : reducers.emptyReducer,
        [settings.stateLocations.LiveChat.Base] : reducers.emptyReducer,
        [settings.stateLocations.FeedbackAppEvent.Base] : reducers.endFeedbackReducer,
        [settings.stateLocations.OutputMasking.Base] : reducers.emptyReducer,
        [settings.stateLocations.Offers.Base] : reducers.launchOffersProcessor,
    });

    return reduceReducers(
        rootReducer,
        reducers.accessKeyHandler,
        reducers.advocacyReducer,
        persistenceReducer,
        reducers.initializeReducer,
        reducers.liveChatFoundationReducer,
        reducers.livechatReducer,
        reducers.generateNewSessionReducer,
        reducers.initializationDataHandler, 
        components.userDetailsPostMessageHandler.getReducer(),
        reducers.launchMessageProcessorReducer,
        reducers.stateTriggerer,
        reducers.skinnerReducer, 
        reducers.stateCopierReducer,
        reducers.stateTriggerer,
        reducers.changeRoleIdProcessor,
        reducers.changeLocaleProcessor,
        reducers.searchInputProcessor,
        reducers.platformIdProcessor,
        reducers.processLocale,
        components.channelManager.getReducer()
    );


}

export {
    setupReducers
};



// WEBPACK FOOTER //
// ./src/setup-reducers.js